<template>
  <div
    :class="`row justify-center bg-${backgroundColor}`"
    v-if="displayComponent"
  >
    <div
      :class="`row full-width justify-${justify}`"
      :style="{ maxWidth: maxWidth ? maxWidth : undefined }"
    >
      <SAILink
        :label="orgContactEmail"
        :href="`mailto:${orgContactEmail}`"
        target="_blank"
        :color="textColor"
        class="q-py-sm q-px-md"
        v-if="orgContactEmail"
      />
      <QSeparator
        class="o-30"
        vertical
        :color="separatorColor"
        v-if="orgContactEmail && (orgContactPhone || faqLink)"
      />
      <SAILink
        :label="orgContactPhone"
        :href="`tel:${orgContactPhone}`"
        target="_blank"
        :color="textColor"
        class="q-py-sm q-px-md"
        v-if="orgContactPhone"
      />
      <QSeparator
        class="o-30"
        v-if="orgContactPhone && faqLink"
        vertical
        :color="separatorColor"
      />
      <SAILink
        label="FAQ'S"
        :href="faqLink"
        target="_blank"
        :color="textColor"
        class="q-py-sm q-px-md"
        v-if="faqLink"
      />
    </div>
  </div>
</template>

<script>
import { QSeparator } from 'quasar';
import SAILink from '../../atom/sai-link';

export default {
  name: 'SAIOrgHeader',
  props: {
    orgContactEmail: String,
    orgContactPhone: String,
    faqLink: String,
    backgroundColor: {
      type: String,
      default: 'application-primary'
    },
    textColor: {
      type: String,
      default: 'white'
    },
    separatorColor: {
      type: String,
      default: 'grey-4'
    },
    maxWidth: {
      type: String,
      default: '100%'
    },
    justify: {
      type: String,
      default: 'end'
    }
  },
  computed: {
    displayComponent() {
      return this.orgContactEmail || this.orgContactPhone || this.faqLink;
    }
  },
  components: {
    QSeparator,
    SAILink
  }
};
</script>
